var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.RESULTS),function(result,r){return _c('v-list-item',{key:r,on:{"click":function($event){return _vm.selectLayer(r)}}},[_vm._v(" "+_vm._s(_vm.getLayerTitle(result.features[0].id))+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }